import styled from 'styled-components';
import { COMMON, LAYOUT, POSITION } from '../constants';
export const Position = styled.div.withConfig({
  displayName: "Position",
  componentId: "s6ls2x-0"
})(["", ";", ";", ";"], COMMON, LAYOUT, POSITION);
Position.propTypes = { ...COMMON.propTypes,
  ...LAYOUT.propTypes,
  ...POSITION.propTypes
};
Position.displayName = 'Position'; // Absolute

export const Absolute = styled(Position).withConfig({
  displayName: "Position__Absolute",
  componentId: "s6ls2x-1"
})([""]);
Absolute.defaultProps = {
  position: 'absolute'
};
Absolute.displayName = 'Absolute'; // Fixed

export const Fixed = styled(Position).withConfig({
  displayName: "Position__Fixed",
  componentId: "s6ls2x-2"
})([""]);
Fixed.defaultProps = {
  position: 'fixed'
};
Fixed.displayName = 'Fixed'; // RELATIVE

export const Relative = styled(Position).withConfig({
  displayName: "Position__Relative",
  componentId: "s6ls2x-3"
})([""]);
Relative.defaultProps = {
  position: 'relative'
};
Relative.displayName = 'Relative'; // STICKY

export const Sticky = styled(Position).withConfig({
  displayName: "Position__Sticky",
  componentId: "s6ls2x-4"
})([""]);
Sticky.defaultProps = {
  position: 'sticky',
  top: 0,
  zIndex: 1
};
Sticky.displayName = 'Sticky';